import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=bc55dd44&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=bc55dd44&prod&lang=scss&scoped=true&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=bc55dd44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc55dd44",
  null
  
)

export default component.exports